import * as t from "io-ts";

export const codec = t.union([
    t.literal("square_meters"),
    t.literal("square_feet"),
]);

export type T = t.TypeOf<typeof codec>;

export const toSuffix = (v: T): string =>
    v === "square_meters" ? "sq m" : "sq ft";
